import { FileIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Document = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <FileIcon {...rest} size={Sizes[size]} color={fill} />;
};

Document.displayName = 'Document';
